module.exports = __webpack_public_path__ + "assets/img/xiamen.313023aa.png";